import { get } from "$ACTIONS/TlcRequest";
import { ApiPort } from "$ACTIONS/TLCAPI";
import { showResultPopup } from "$ACTIONS/helper";
import moment from "moment";

const restrictionMap = {
    game: "disableBetting",
    deposit: "disableDeposit",
    bonus: "disableBonusApplication",
};

/**
 * 檢查是否設置自我限制，並根據類別判斷是否彈出提示
 *
 * @param {Function} dispatchLoading - 控制 loading 狀態的 function（例如 (show) => {}）
 * @param {string} type - 檢查類別，例如 'game', 'deposit', 'bonus'
 * @param {Function} [onRestrictedConfirm] - （選填）彈窗按紐執行
 * @returns {Promise<boolean>} - true 表示被限制並已彈窗，false 表示無限制可繼續
 */
export async function checkUserSelfExclusion(dispatchLoading, type, onRestrictedConfirm) {
    if (typeof dispatchLoading === "function") {
        dispatchLoading(true);
    }

    try {
        const res = await get(ApiPort.GETSelfExclusions);
        const result = res?.result;

        const restrictionField = restrictionMap[type];

        if (res && result && result.status && restrictionField && result[restrictionField]) {
            const { selfExcludeDuration, selfExcludeSetDate, selfExclusionSettingID } = result;
            const dayRangeStr = selfExclusionSettingID == 3 ? "แบบถาวร" : `${selfExcludeDuration} วัน`;
            const dateStr = moment(selfExcludeSetDate + "+08:00").format("DD/MM/YYYY");

            showSelfExclusionPopup(dayRangeStr, dateStr, onRestrictedConfirm);
            return true;
        }

        return false;
    } catch (e) {
        console.error("SelfExclusion API error:", e);
        return false;
    } finally {
        if (typeof dispatchLoading === "function") {
            dispatchLoading(false);
        }
    }
}

/**
 * 顯示 Self Exclusion 彈窗（用於通知玩家已設定自我限制）
 *
 * @param {string} dayRangeDisplayStr - 顯示的限制天數文字，例如 "7 วัน" 或 "แบบถาวร"
 * @param {string} dateStr - 顯示的設定日期，例如 "03/04/2025"
 * @param {Function} [onRestrictedConfirm] -（選填）當使用者點擊按鈕時要執行的行為，例如導回首頁
 */
export function showSelfExclusionPopup(dayRangeDisplayStr, dateStr, onRestrictedConfirm) {
    showResultPopup({
        type: "confirm",
        title: "ตั้งค่าส่วนตัว",
        content: (
            <>
                คุณได้ตั้งข้อจำกัดของตนเอง ({dayRangeDisplayStr})
                <br />
                เมื่อวันที่ {dateStr} เรียบร้อยแล้ว
                <br />
                หากต้องการความช่วยเหลือ
                <br />
                โปรดติดต่อฝ่ายบริการ
            </>
        ),
        okText: "ตกลง", // 我知道了
        cancelText: "ติดต่อห้องช่วยเหลือสด", // 联系客服
        onOk: () => {
            if (typeof onRestrictedConfirm === "function") {
                onRestrictedConfirm();
            }
        },
        onCancel: () => {
            global?.PopUpLiveChat?.();
            if (typeof onRestrictedConfirm === "function") {
                onRestrictedConfirm();
            }
        },
    });
}
